import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearClientVehiclesAction,
  clearSelectedClientAction,
  getClientVehiclesAction,
} from '../../redux/actions/clientsActions';

const useFetchClientVehicles = () => {
  const dispatch = useDispatch();
  const client = useSelector((state) => state.clients?.client);
  const vehicles = useSelector((state) => state.clients?.vehicles);
  const loading = useSelector((state) => state.clients?.vehiclesLoading);

  const fetchClientVehicles = useCallback(async () => {
    await dispatch(getClientVehiclesAction(client.id));
  }, [client, dispatch]);

  useEffect(() => {
    fetchClientVehicles();
  }, [fetchClientVehicles]);

  useEffect(() => {
    return () => {
      dispatch(clearClientVehiclesAction());
      dispatch(clearSelectedClientAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchClientVehicles();
  };

  return { loading, vehicles, refresh };
};

export default useFetchClientVehicles;
